import { render, staticRenderFns } from "./VxAutoSuggest.vue?vue&type=template&id=f23777e2"
import script from "./VxAutoSuggest.vue?vue&type=script&lang=js"
export * from "./VxAutoSuggest.vue?vue&type=script&lang=js"
import style0 from "./VxAutoSuggest.vue?vue&type=style&index=0&id=f23777e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports